export default {
  list: { lazy: () => import('./batteryComponents'), component: 'ComponentBatteryList' },
  edit: { lazy: () => import('./batteryComponents'), component: 'ComponentBatteryEdit' },
  create: { lazy: () => import('./batteryComponents'), component: 'ComponentBatteryCreate' },
}
